<script lang="ts">
	import type { User } from "luxedo-data"
	import type { BundledAccountData } from "luxedo-rpc/src/types/BundledTypes"
	import { viewUser } from "../../../modules/page-events/navigator"

	interface Props {
		user: User | BundledAccountData;
	}

	let { user }: Props = $props();

	function handleClick() {
		viewUser(user)
	}
</script>

<tr
	role="button"
	onclick={handleClick}
	onkeypress={(e) => {
		if (e.key === "Enter") handleClick()
	}}
	tabindex="0"
>
	<td>
		{user.id}
	</td>

	<td>
		{user.lastname}, {user.firstname}
	</td>
	<td>
		{user.email}
	</td>
</tr>

<style>
	tr {
		cursor: pointer;
		transition: background-color var(--transition-duration), color var(--transition-duration);
	}

	tr td:first-of-type {
		padding-left: 1rem;
		border-top-left-radius: var(--br);
		border-bottom-left-radius: var(--br);
	}

	tr td:last-of-type {
		padding-right: 1rem;
		border-top-right-radius: var(--br);
		border-bottom-right-radius: var(--br);
	}

	tr:focus-visible,
	tr:hover {
		background-color: var(--color-accent);
		color: var(--color-text-light);
	}
</style>
